/**
 * @fileoverview GET handler for the "/:app_group_id/canvas/:workflow_id/step/:step_id/message/:message_variation_id" endpoint
 */
import { reactQueryFetcherAdapter } from "@dashboardApi/apis/reactQueryFetcherAdapters";

import type { MessageType } from "@lib/campaignMessageTypeConstants";
import fetch from "@lib/fetch";

import { appGroupIdCanvasWorkflowIdStepStepIdMessageMessageVariationId } from "./constants";
import type { MessageResult } from "./types";

export const getMessage = reactQueryFetcherAdapter(
  appGroupIdCanvasWorkflowIdStepStepIdMessageMessageVariationId,
  (
    signal: AbortSignal,
    appGroupId: string,
    workflowId: string,
    stepId: string,
    messageVariationId: string
  ): Promise<MessageResult<MessageType, unknown>> => {
    return fetch(
      `/${appGroupId}/canvas/${workflowId}/step/${stepId}/message/${messageVariationId}`,
      "GET",
      {},
      { signal }
    );
  }
);
